import React, { useState, useEffect } from 'react'
import { client } from '../../utils'
import PropTypes from 'prop-types'
import { Link, Redirect } from 'react-router-dom'
import { NewExceptionBar } from './NewExceptionBar'
import { ReviewButton } from './ReviewButton'
import { useStateValue } from '../state'
import { adaExceptions as endpoints } from '../../api_urls'
import { ProgressBar } from './ProgressBar'
import ButterToast, { Cinnamon } from 'butter-toast'

export const Review = props => {
  const [currentState, dispatch] = useStateValue()
  const [currentActivities, setCurrentActivities] = useState([])
  const [redirectToExceptions, setRedirectToExceptions] = useState(false)
  const [isDone, setIsDone] = useState(false)
  const [reviewProgressBarCheck, setReviewProgressBarCheck] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (currentState.exceptionType === 'grantExtraTime') {
      setCurrentActivities(currentState.timeLimitRulesList)
    } else {
      setCurrentActivities(currentState.lateRulesList)
    }
  }, [currentState.exceptionType])

  const createException = async () => {
    setReviewProgressBarCheck(true)
    setTimeout(() => {
      setIsLoading(true)
    }, 250)
    const data = {
      exceptionType: currentState.exceptionType,
      extraTime: currentState.extraTime,
      shiftDays: currentState.shiftDays,
      shiftHours: currentState.shiftHours,
      shiftMinutes: currentState.shiftMinutes,
      override: currentState.override,
      selectedAssignments: currentState.selectedAssignments,
      studentId: props.match.params.studentid,
    }

    try {
      let resp = await client.post(endpoints.createException(), data)
      setIsLoading(false)
      setIsDone(true)
      dispatch({
        type: 'updateAggregatedRules',
        aggregatedRules: resp.data.aggregatedRules,
      })
      setTimeout(() => {
        setRedirectToExceptions(true)
        dispatch({ type: 'resetException' })
      }, 1500)
    } catch (err) {
      setIsLoading(false)
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={`There was an error trying to create exceptions. ${err}`}
            scheme={Cinnamon.Crisp.SCHEME_RED}
            icon={<i className="far fa-exclamation-triangle fa-3x" />}
          />
        ),
      })
    }
  }

  if (redirectToExceptions || currentState.exceptionType === '') {
    return (
      <Redirect
        to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/`}
      />
    )
  }
  return (
    <div>
      {isLoading ? (
        <div
          className="icon icon_spinner10 icon_spin2 spinner LoadingSpinner d-flex justify-content-center"
          style={{ fontSize: '26pt', color: 'green', marginBottom: '57px' }}
        />
      ) : (
        <ProgressBar
          createException={false}
          selectAssignments={false}
          review
          isDone={isDone}
          reviewProgressBarCheck={reviewProgressBarCheck}
        />
      )}
      <div className="d-flex justify-content-center">
        <NewExceptionBar displayRemoveButton={false} />
      </div>
      <div className="d-flex justify-content-center">
        <div className="panel panel-primary w-75">
          <div
            className="panel-heading pl-2"
            style={{ fontSize: '13pt', height: '40px', paddingTop: '7px' }}
          >
            Assignments
          </div>
          <div className="panel-body">
            {currentActivities.map((activity, idx) => {
              if (activity.id in currentState.selectedAssignments) {
                return <ReviewButton key={idx} activity={activity} />
              }
            })}
          </div>
        </div>
      </div>
      <button
        className="btn btn-myed btn-primary btn-primary-myed pull-right"
        onClick={() => {
          createException()
        }}
      >
        Add Exceptions
      </button>
      <Link
        className="btn btn-myed btn-default btn-default-myed mt-2 pull-right"
        to={`/instructor/ada_exceptions/${props.match.params.coursenum}/${props.match.params.studentid}/select_assignments`}
      >
        Back
      </Link>
      <div className="pull-left" style={{ position: 'absolute', bottom: '0' }}>
        *All dates displayed in {currentState.timezone}.
      </div>
    </div>
  )
}

Review.propTypes = {
  match: PropTypes.object.isRequired,
}
